import React, { useState, useContext } from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { Button } from '@material-ui/core';
import PaymentForm from './PaymentForm'
import AuthContext from '../../context/auth-context'
import mPayment from './Payment.controller'
import { isArray } from 'util';
import validate from 'validate.js'
import DialogInfo from '../../Dialog/DialogInfo'

const PaymentAdd = (props) => {
    const kodeoutlet = props.match.params.kodeoutlet;
    const { clientID, token } = useContext(AuthContext)
    const [OpenConfirmInfo, setOpenConfirmInfo] = useState(false)
    const [dialogtext, setDialogtext] = useState()
    const [dialogUrl, setDialogUrl] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const validateForm = () => {
        const { namapayment } = state;
        const prompayment = new Promise((resolve, reject) => {
            const constraint = {
                namapayment: {
                    length: {
                        minimum: 3,
                        message: "Nama Payment minimal terdiri dari 3 huruf"
                    },
                }
            }
            const validator = validate({ namapayment }, constraint, { fullMessages: false });
            if (validator === undefined) {
                resolve();
            } else {
                reject(validator);
            }
        })
        return Promise.all([prompayment]);
    }
    const handleSimpan = () => {
        setIsLoading(true)
        validateForm().then(() => {
            mPayment.simpanPayment(kodeoutlet, state.namapayment, state.isAutoFill, state.isCard, clientID, token).then(resp => {
                setIsLoading(false)
                if (resp) {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>Data berhasil di simpan<p/>`)
                    setDialogUrl(`/manajemenoutlet/${kodeoutlet}/payment/1/5`)
                } else {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>Gagal Menyimpan Data<p/>`)
                }
            }).catch(err => {
                setIsLoading(false)
                if (isArray(err) && err.length > 0) {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>Gagal Simpan : ${err[0].message}<p/>`)
                } else if (typeof err == 'error') {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>${err.message}<p/>`)
                } else {
                    console.log(err);
                }
            })
        }).catch(err => {
            setIsLoading(false)
            const keys = Object.keys(err);
            var errorMessage = "";
            for (const key of keys) {
                errorMessage += err[key] + "\n";
            }
            setOpenConfirmInfo(true)
            setDialogtext(`<p>${errorMessage}<p/>`)
        })
    }

    const [state, setState] = useState({
        kodepayment: '',
        namapayment: '',
        isCard: false,
        isAutoFill: false
    })

    const handleChange = (key, value) => {
        const newState = Object.assign({}, state);
        newState[key] = value;
        setState(newState);
    }
    return (
        <Container>
            <PaymentForm history={props.history} kodeoutlet={kodeoutlet} kodepayment={state.kodepayment} namapayment={state.namapayment} isCard={state.isCard} isAutoFill={state.isAutoFill} handleChange={handleChange} />
            <Row style={{ marginTop: 20, marginBottom: 20 }}>
                <Col xs={12} className="text-center">
                    <Button variant="contained" color="primary" onClick={handleSimpan} disabled={isLoading}>Simpan</Button>
                </Col>
            </Row>
            <DialogInfo open={OpenConfirmInfo} setOpen={setOpenConfirmInfo} text={dialogtext} url={dialogUrl} redirect={props.history.push} />
        </Container>
    )
}

export default PaymentAdd;